import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Customecommerceportfolio() {
  return (
    <section className="custom-ecommerce-portfolio p-100">
      <Container>
        <div className="ecomm-port-box">
          <h2 className="text-center mb-5">
            Retail Super App Success by TekRevol
          </h2>
          <Row>
            <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="mb-4 mb-lg-0">
              <div className="icon">
                <StaticImage
                  src="../../images/services-usa/retail-app/yeppy-logo.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={186}
                  height={50}
                />
              </div>
              <div className="content">
                <h3>Yeppy</h3>
                <p>
                  Yeppy aimed to consolidate multiple daily-use services like
                  financial, booking, and retail into a single seamless mobile
                  app. TekRevol built a versatile super app that simplifies user
                  experience by integrating diverse functionalities into one
                  platform, reducing app fragmentation.
                </p>
                <h5>The result</h5>
                <ul>
                  <li>
                    {" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="none"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill="#F47A1F"
                        d="M9.86 19.874A9.85 9.85 0 0 1 0 10.014 9.85 9.85 0 0 1 9.86.154a9.85 9.85 0 0 1 9.86 9.86 9.85 9.85 0 0 1-9.86 9.86m0-18.56a8.69 8.69 0 0 0-8.7 8.7c0 4.814 3.886 8.7 8.7 8.7s8.7-3.886 8.7-8.7-3.886-8.7-8.7-8.7"
                      ></path>
                      <path
                        fill="#F47A1F"
                        d="M8.7 14.309 3.654 9.263l.812-.812L8.7 12.685l6.554-6.554.812.812z"
                      ></path>
                    </svg>
                    Increased active users by 50%
                  </li>
                  <li>
                    {" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="none"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill="#F47A1F"
                        d="M9.86 19.874A9.85 9.85 0 0 1 0 10.014 9.85 9.85 0 0 1 9.86.154a9.85 9.85 0 0 1 9.86 9.86 9.85 9.85 0 0 1-9.86 9.86m0-18.56a8.69 8.69 0 0 0-8.7 8.7c0 4.814 3.886 8.7 8.7 8.7s8.7-3.886 8.7-8.7-3.886-8.7-8.7-8.7"
                      ></path>
                      <path
                        fill="#F47A1F"
                        d="M8.7 14.309 3.654 9.263l.812-.812L8.7 12.685l6.554-6.554.812.812z"
                      ></path>
                    </svg>
                    Reduced app switching by 40%
                  </li>
                  <li>
                    {" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="none"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill="#F47A1F"
                        d="M9.86 19.874A9.85 9.85 0 0 1 0 10.014 9.85 9.85 0 0 1 9.86.154a9.85 9.85 0 0 1 9.86 9.86 9.85 9.85 0 0 1-9.86 9.86m0-18.56a8.69 8.69 0 0 0-8.7 8.7c0 4.814 3.886 8.7 8.7 8.7s8.7-3.886 8.7-8.7-3.886-8.7-8.7-8.7"
                      ></path>
                      <path
                        fill="#F47A1F"
                        d="M8.7 14.309 3.654 9.263l.812-.812L8.7 12.685l6.554-6.554.812.812z"
                      ></path>
                    </svg>
                    Boosted transaction volume by 30%
                  </li>
                </ul>
                <Link
                  style={{ background: "#f47a14", color: "#fff" }}
                  to="/case-studies/yeppy"
                  className="border_btn"
                  aria-label="TekRevol Contact"
                >
                  View Case Study
                </Link>
              </div>
            </Col>
            <Col
              xs={12}
              md={12}
              lg={6}
              xl={6}
              xxl={6}
              className="text-center my-auto"
            >
              <StaticImage
                src="../../images/services-usa/retail-app/yeppy.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={432}
                height={420}
              />
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Customecommerceportfolio;
